// removed by extract-text-webpack-plugin
module.exports = {"loader":"Loader__loader-23mN3"};